<template>
    <div>
        <draggable handle=".drag" v-model="list" >
            <div v-for="(data, key) in list" class="line">
                <div class="drag">
                    <svg>
                        <use xlink:href="#icon-drag"></use>
                    </svg>
                </div>
                <span class="nb">
                    C{{key+1}}
                </span>
                <div>
                    <input type="text" v-model="data.value" placeholder="Valeur" @blur="update(key)" style="margin-top:0px"/>
                </div>
                <btn ico="add" color="blue" @click="insert(key)" v-if="key>0" style="margin-top:0px"></btn>
                <btn ico="delete" color="red" @click="remove(key)" v-if="key>0" style="margin-top:0px"></btn>
            </div>
        </draggable>
        <div class="line option">
            <btn text="Ajouter un choix" ico="add" @click="add" style="margin-top:0"></btn>
        </div>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import tools from '../../config.ts';
    import draggable from 'vuedraggable'

    export default {
        name: "Checkbox",
        components: {Btn,draggable},
        props: {
            type: "",
            content: {},
        },
        data(){
            return{
                list:[],
                loaded : false,
            }
        },
        methods: {
            add() {
                this.content.push({value: "", id : new Date().getTime()});

                tools.$emit("updateQuestions")
            },
            remove(key) {
                this.content.splice(key, 1)

                tools.$emit("updateQuestions")
            },
            insert(key){
                this.content.splice(key + 1, 0,{value : ""})
            },
            update(key){
                this.$emit("update",this.list);
            }
        },
        watch: {
            content (){
                this.list = this.content;
            },
            // list (){
            //     if(!this.loaded){
            //         return;
            //     }
            //     this.$emit("update",this.list);
            // }
        },
        mounted(){
            this.list = this.content;
            this.loaded = true;
        }
    }
</script>
